import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceitaArrecadada = '/service/contabilidade/transparencia/receita/'

class ReceitaArrecadadaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(data) {
        let json = {
            exercicio: data.exercicio,
            mes: data.mes,
            administracao: data.administracao ? data.administracao : this.state.adms,
            recurso: data.recurso,
            destinacao: data.destinacao,
            tipoRecurso: data.tipoRecurso,
            sequencia: data.sequencia,
            grau: data.grau ? data.grau : null,
        }
        return this.conex.post(urlReceitaArrecadada + 'receitaArrecadada/', JSON.stringify(json))
    }
}

export default ReceitaArrecadadaService
